import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "filter-container" }

import { getCurrentInstance, reactive, ref, onMounted } from 'vue'
import Pagination from '@/components/Pagination.vue'
import { getHnUserList } from '@/apis/order'

export default /*@__PURE__*/_defineComponent({
  __name: 'ScalperUser',
  setup(__props) {

const { proxy } = getCurrentInstance() as any

// 搜索表单
const searchForm = reactive({
    id: '',
    username: ''
})

// 表格数据
const userList = ref([])
const total = ref(0)
const currentPage = ref(1)
const pageSize = ref(10)

// 获取列表数据
const getList = async () => {
    const params = {
        ...searchForm,
        page: currentPage.value,
        page_size: pageSize.value
    }
    const res = await getHnUserList(params)
    if (res.code == 200) {
        userList.value = res.data.data || []
        total.value = res.data.total || 0
    }else {
        proxy.$message.error(res.msg)
    }
}

// 搜索
const handleSearch = () => {
    getList()
}

// 分页
const handleSizeChange = (size: number) => {
    pageSize.value = size
    currentPage.value = 1
    getList()
}

const handleCurrentChange = (current: number) => {
    currentPage.value = current
    getList()
}

// 初始化
onMounted(() => {
    getList()
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_input, {
        modelValue: searchForm.id,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchForm.id) = $event)),
        placeholder: "用户ID",
        class: "filter-item"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        modelValue: searchForm.username,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchForm.username) = $event)),
        placeholder: "手机号",
        class: "filter-item"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: handleSearch
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [
          _createTextVNode("搜索")
        ])),
        _: 1
      })
    ]),
    _createVNode(_component_el_table, {
      data: userList.value,
      stripe: "",
      border: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "id",
          label: "用户ID",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          prop: "username",
          label: "手机号"
        }),
        _createVNode(_component_el_table_column, {
          prop: "black_money",
          label: "标记黄牛时的余额"
        }),
        _createVNode(_component_el_table_column, {
          prop: "user_money",
          label: "余额"
        }),
        _createVNode(_component_el_table_column, {
          prop: "status",
          label: "状态"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.status == 0 ? '正常' : '禁用'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "sw_count",
          label: "实物订单数"
        }),
        _createVNode(_component_el_table_column, {
          prop: "coupon_count",
          label: "电子券订单"
        }),
        _createVNode(_component_el_table_column, {
          prop: "movie_count",
          label: "电影票订单"
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(Pagination, {
      currentPage: currentPage.value,
      total: total.value,
      onPageChange: handleCurrentChange,
      onSizeChange: handleSizeChange
    }, null, 8, ["currentPage", "total"])
  ]))
}
}

})